import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  dialogStyles: {
    alignItems: 'self-start',
    padding: 25,
    paddingBottom: 0,
  },
  container: {
    width: 600,
  },
  buttonContainer: {
    justifyContent: 'flex-end',
  },
  checkBoxContainer: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center',
  },
  colorPickerContainer: {
    marginTop: 30,
  }
}));
